import { Blockfrost } from "@blaze-cardano/query";
import { Blaze, type CIP30Interface, WebWallet } from "@blaze-cardano/sdk";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import { FC, PropsWithChildren, useEffect } from "react";

import { AppActions, useAppContext } from "@/context/AppContext";
import { ensureEphemeralWallet } from "@/lib/ephemeralWallet";

export const SetupBlazeProvider: FC<PropsWithChildren> = ({ children }) => {
  const { observer, mainAddress } = useWalletObserver();
  const { dispatch } = useAppContext();

  useEffect(() => {
    const provider = new Blockfrost({
      network:
        window.__APP_CONFIG.env === "mainnet"
          ? "cardano-mainnet"
          : "cardano-preview",
      projectId: window.__APP_CONFIG.blockfrostProjectId,
    });
    AppActions.setProviderInstance(provider, dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!observer.api) {
      AppActions.setBlazeInstance(undefined, dispatch);
      return;
    }

    let cancelled = false;
    const provider = new Blockfrost({
      network:
        window.__APP_CONFIG.env === "mainnet"
          ? "cardano-mainnet"
          : "cardano-preview",
      projectId: window.__APP_CONFIG.blockfrostProjectId,
    });

    (async () => {
      try {
        const blaze = await Blaze.from(
          provider,
          new WebWallet(observer.api as CIP30Interface),
        );
        if (!cancelled) {
          AppActions.setBlazeInstance(blaze, dispatch);
        }
      } catch (err) {
        console.warn("Failed to initialize Blaze wallet:", err);
        if (!cancelled) {
          AppActions.setBlazeInstance(undefined, dispatch);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [dispatch, observer.api]);

  useEffect(() => {
    if (!mainAddress) {
      return;
    }

    void ensureEphemeralWallet(mainAddress);
  }, [mainAddress]);

  return children;
};
